import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';
import VueMeta from "vue-meta";
import i18n from "./i18n";
import Emitter from 'tiny-emitter';
import "./css/main.css";
import './css/index.css';
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";
import { library } from "@fortawesome/fontawesome-svg-core"; /* FontAwesome Component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VueGoodTablePlugin from 'vue-good-table';

//import PrimeVue
import 'primevue/resources/themes/lara-light-blue/theme.css'
import 'primeicons/primeicons.css'
import PrimeVue from "primevue/config";
Vue.use(PrimeVue);

// import the styles
import 'vue-good-table/dist/vue-good-table.css'

Vue.use(VueGoodTablePlugin);
import {
  faFontAwesome,
  faFacebookSquare
} from "@fortawesome/free-brands-svg-icons";
import {
  faBell,
  faInfoCircle,
  faCheckCircle,
  faExclamationTriangle,
  faExclamationCircle,
  faExclamation,
  faSearch,
  faLock,
  faTimes,
  faClock,
  faShoppingCart,
  faEuroSign,
  faInfo,
  faChevronDown,
  faChevronUp,
  faShareSquare,
  faTruck,
  faHandHoldingUsd,
  faCar,
  faQuestionCircle,
  faCaretDown,
  faChevronLeft,
  faChevronRight,
  faBars,
  faArrowDown,
  faArrowUp,
  faArrowLeft,
  faArrowRight,
  faHeart,
  faEllipsisV,
  faStopwatch,
  faCheck,
  faClipboardList,
  faBellSlash,
  faRobot,
  faSpinner,
  faCalendarAlt,
  faTrash,
  faUpload,
  faTimesCircle,
  faEdit,
  faSave,
  faPrint,
  faLockOpen,
  faFileExport,
  faPlusCircle,
  faPencilAlt,
  faSignOutAlt,
  faList,
  faQrcode,
  faBan,
  faFile,
  faUndo,
  faHistory,
  faFileUpload,
  faUserAlt,
  faPaperclip,
  faTools,
  faEye,
  faEyeSlash,
  faComment,
  faExchangeAlt,
  faPlus,
  faLevelUpAlt,
  faPercentage,
  faPercent,
  faChain,
  faBuilding,
  faCalculator,
  faGlobe,
  faThumbsDown,
  faThumbsUp,
  faHourglassEnd,
  faFileArrowUp,
  faFileArrowDown,
  faMagnifyingGlassChart,
  faFileCircleCheck,
  faFileCircleExclamation,
  faFileCircleQuestion,
  faExpandArrowsAlt,
  faMinimize,
  faXmark,
  faClone,
  faUserMinus, 
} from "@fortawesome/free-solid-svg-icons";

import { faFilePdf, faFlag, faUser, faPenToSquare, faCopy, faPaste } from "@fortawesome/free-regular-svg-icons";

library.add(faXmark);
library.add(faFileCircleQuestion);
library.add(faFileCircleExclamation);
library.add(faFileCircleCheck);
library.add(faMagnifyingGlassChart);
library.add(faFileArrowUp);
library.add(faFileArrowDown);
library.add(faHourglassEnd);
library.add(faThumbsUp);
library.add(faThumbsDown);
library.add(faGlobe);
library.add(faUser);
library.add(faCalculator);
library.add(faBuilding);
library.add(faChain);
library.add(faBell);
library.add(faPercentage);
library.add(faPercent);
library.add(faInfoCircle);
library.add(faCheckCircle);
library.add(faExclamationTriangle);
library.add(faExclamationCircle);
library.add(faExclamation);
library.add(faSearch);
library.add(faLock);
library.add(faTimes);
library.add(faClock);
library.add(faShoppingCart);
library.add(faEuroSign);
library.add(faInfo);
library.add(faChevronDown);
library.add(faChevronUp);
library.add(faShareSquare);
library.add(faTruck);
library.add(faHandHoldingUsd);
library.add(faCar);
library.add(faQuestionCircle);
library.add(faCaretDown);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faFontAwesome);
library.add(faFacebookSquare);
library.add(faBars);
library.add(faArrowDown);
library.add(faArrowUp);
library.add(faArrowLeft);
library.add(faArrowRight);
library.add(faEllipsisV);
library.add(faHeart);
library.add(faStopwatch);
library.add(faCheck);
library.add(faFilePdf);
library.add(faClipboardList);
library.add(faBellSlash);
library.add(faRobot);
library.add(faSpinner);
library.add(faCalendarAlt);
library.add(faTrash);
library.add(faUpload);
library.add(faTimesCircle);
library.add(faEdit);
library.add(faSave);
library.add(faPrint);
library.add(faLockOpen);
library.add(faFileExport);
library.add(faPlusCircle);
library.add(faPencilAlt);
library.add(faSignOutAlt);
library.add(faList);
library.add(faQrcode);
library.add(faBan);
library.add(faFile);
library.add(faUndo);
library.add(faHistory);
library.add(faFileUpload);
library.add(faUserAlt);
library.add(faPaperclip);
library.add(faTools);
library.add(faEye);
library.add(faEyeSlash);
library.add(faFlag);
library.add(faComment);
library.add(faExchangeAlt);
library.add(faPlus);
library.add(faLevelUpAlt);
library.add(faExpandArrowsAlt);
library.add(faMinimize);
library.add(faClone);
library.add(faCopy);
library.add(faPenToSquare);
library.add(faUserMinus);
library.add(faPaste);

import LoadScript from 'vue-plugin-load-script';
Vue.use(LoadScript);

import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(VueToast, {
  // One of the options
  position: "top-right",
  duration: 7000
});

Vue.config.productionTip = false;

Vue.use(Emitter);

Vue.use(VueMeta, {
  keyName: "metaInfo",
  attribute: "data-vue-meta",
  tagIDKeyName: "vmid",
  refreshOnceOnNavigation: true,
  debounceWait: 20,
  waitOnDestroyed: true,
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
